import DictionaryManagement from "./DictionaryManagement";

export default DictionaryManagement;
